export const SALES_PHONE_E164 = '+905469191134';
export const SALES_PHONE_READABLE = '0546 919 11 34';
export const SUPPORT_PHONE_E164 = '+902165193411';
export const SUPPORT_PHONE_READABLE = '0216 519 34 11';
export const SUPPORT_PHONE_INTL = '+90 216 519 34 11';
export const SALES_PHONE_INTL = '+90 546 919 11 34';

export function buildWhatsAppUrl(message: string) {
  const text = encodeURIComponent(message);
  return `https://wa.me/${SALES_PHONE_E164.replace('+', '')}?text=${text}`;
}
